import { searchComicsRecomended } from "@/api/comics";
import { useQuery } from "@tanstack/react-query";

const useSearchComicsRecomended = (
  page?: number,
  size?: number,
  sort?: Array<string>
) => {
  const { data: { data: comicsList } = {}, ...rest } = useQuery(
    ['comicsListRecomended', page, size, sort],
    () => searchComicsRecomended(page, size, sort),
    {
      retry: 1,
      enabled: page !== null,
    }
  );

  return {
    comicsList,
    ...rest,
  };
};

export default useSearchComicsRecomended;



